module.exports = __webpack_public_path__ + "static/media/roundaboutCW90.0032fe9b.svg";